export class OAuthVerifier {
    static key = "oauth_code_verifier";
    static setCodeVerifier(value) {
        sessionStorage.setItem(OAuthVerifier.key, value);
    }
    // getting code verifier can be done only once for security reasons
    // if value in result is expected
    static getCodeVerifier() {
        const result = sessionStorage.getItem(OAuthVerifier.key);
        sessionStorage.removeItem(OAuthVerifier.key);
        return result;
    }
}
